import { useCallback, useEffect, useState } from "react";
import { CardAnalytics, CardAnalyticsXl, CustomMainContent } from "../../components";
import { CardAverageTime, CardChartBar, CardRadialBar, CardRepeatPerUser, CardUsersParticipate } from "../common";
import { correctResponsesByQuestions, countUsersParticipate, getAverageCorrectAnswers, getAverageRepetitionsforUser, getAverageTimePerUser } from "../../redux/helpers";
import { useSelector } from "react-redux";
import { PrincipalHeader } from "../VrLearning/templates/PrincipalHeader";
import { HelpButtonsTraining } from "./templates/HelperButtonsTraining";

const TrinigAnalytics = () => {
    const { responses } = useSelector(state => state.vrtSlice)
    const { arrayData } = useSelector(state => state.table)

    const [hasFilter, setHasFilter] = useState(false);
    const [dateRange, setDataRange] = useState(null);
    const [averageResponses, setAverageResponses] = useState(0)
    const [timeAverage, setTimeAverage] = useState(0)
    const [repetByUsers, setRepetByUsers] = useState(0)
    const [totalUsersParticipate, setTotalUsersParticipate] = useState(0)
    const [responsesCorrect, setResponsesCorrect] = useState([])

    const setDefaultData = useCallback(
        () => {
            // this need a crud Data api
            setTimeAverage(getAverageTimePerUser(responses, new Date(2020, 0, 1), new Date()))
            setResponsesCorrect(correctResponsesByQuestions(responses, new Date(2020, 0, 1), new Date()))
            // 
            setAverageResponses(getAverageCorrectAnswers(arrayData, new Date(2020, 0, 1), new Date()))
            setRepetByUsers(getAverageRepetitionsforUser(arrayData, new Date(2020, 0, 1), new Date()))
            setTotalUsersParticipate(countUsersParticipate(arrayData, new Date(2020, 0, 1), new Date()))
        },
        [arrayData, responses],
    )


    useEffect(() => {
        setDefaultData()
    }, [responses, arrayData, setDefaultData])

    const onChangeFilter = (value) => {
        setHasFilter(value)
        if (!value) {
            setDefaultData()
        }
        else if (dateRange) {
            const startD = dateRange[0].toDate()
            const endD = dateRange[1].toDate()
            // this need a crud Data api
            setTimeAverage(getAverageTimePerUser(responses, startD, endD))
            // 
            setAverageResponses(getAverageCorrectAnswers(arrayData, startD, endD))
            setRepetByUsers(getAverageRepetitionsforUser(arrayData, startD, endD))
            setTotalUsersParticipate(countUsersParticipate(arrayData, startD, endD))
            setResponsesCorrect(correctResponsesByQuestions(responses, startD, endD))
        }
    }

    return (
        <CustomMainContent>
            <div className="flex w-full min-w-[450px] h-full  ">
                <div className="w-100-68 overflow-y-auto">
                    <div className="w-full mb-3 h-14 overflow-hidden shadow-md bg-white rounded-xl">
                        <PrincipalHeader
                            hasFilter={hasFilter}
                            setFilter={(value) => onChangeFilter(value)}
                            dateRange={dateRange}
                            setDataRange={setDataRange}
                        />
                    </div>
                    <div className="flex flex-wrap w-full overflow-y-auto">
                        <CardAnalytics title="Tiempo promedio por persona" bottomText="10% desde ultima semana" filter={false}>
                            <CardAverageTime timeAverage={timeAverage} />
                        </CardAnalytics>
                        <CardAnalytics title="Porcentaje promedio completado por persona" filter={false}>
                            <CardRadialBar averageResponses={averageResponses}></CardRadialBar>
                        </CardAnalytics>
                        <CardAnalytics title="Repeticiones hechas por persona" filter={false} bottomText="10% desde ultima semana" >
                            <CardRepeatPerUser repetByUsers={repetByUsers ? repetByUsers : 0} />
                        </CardAnalytics>
                        <CardAnalytics title="Número total de personas registradas en esta capacitación" bottomText="10% desde ultima semana" filter={false}>
                            <CardUsersParticipate users={totalUsersParticipate} />
                        </CardAnalytics>
                        <CardAnalyticsXl title="Reactivos de secciones por persona" filter={false} bigHeight={true}>
                            <CardChartBar responsesData={responsesCorrect}></CardChartBar>
                        </CardAnalyticsXl>

                    </div>
                </div>
                <div className="w-[68px] h-full flex justify-center">
                    <HelpButtonsTraining />
                </div>
            </div>
        </CustomMainContent>
    );
};

export default TrinigAnalytics;
